export function isNotSameSelectItem({ nextValue, value }) {
  return Number(value?.value) !== Number(nextValue.value)
}
